import React, { Compenent } from "react";

const styles = {
  cursorPointer: {
    cursor: "pointer",
  },
};
const MyEventNav = ({ handleOnclick, activePage }) => {
  return (
    <div className="container container-nav">
      <ul
        className="nav nav-pills"
        id="pills-kegiatan-acara-saya"
        role="tablist"
      >
        <li className="nav-item" onClick={() => handleOnclick("myEvent")}>
          <div
            className={`nav-link ${activePage === "myEvent" ? "active" : ""}`}
            id="pills-acara-tab"
            data-toggle="pill"
            role="tab"
            aria-controls="pills-acara"
            aria-selected="true"
            style={styles.cursorPointer}
          >
            Acara Saya
          </div>
        </li>
        <li className="nav-item" onClick={() => handleOnclick("history")}>
          <div
            className={`nav-link ${activePage === "myEvent" ? "" : "active"}`}
            id="pills-riwayat-tab"
            data-toggle="pill"
            role="tab"
            aria-controls="pills-riwayat"
            aria-selected="false"
            style={styles.cursorPointer}
          >
            Riwayat
          </div>
        </li>
      </ul>
    </div>
  );
};
export default MyEventNav;
